// Central react-query keys so realtime events can invalidate precisely.
export const qk = {
  me: ['me'] as const,
  mailboxes: ['mailboxes'] as const,
  folders: (mailboxId: string) => ['folders', mailboxId] as const,
  threads: (params: Record<string, string | undefined>) => ['threads', params] as const,
  threadsRoot: ['threads'] as const,
  thread: (id: string) => ['thread', id] as const,
  attention: (status: 'open' | 'all') => ['attention', status] as const,
  attentionRoot: ['attention'] as const,
  review: (status: 'unreviewed' | 'all') => ['review', status] as const,
  reviewRoot: ['review'] as const,
  ringStatus: ['ring', 'status'] as const,
  drafts: (status?: string) => ['drafts', status ?? 'all'] as const,
  draftsRoot: ['drafts'] as const,
  signatures: ['signatures'] as const,
  contacts: (params: Record<string, string | undefined>) => ['contacts', params] as const,
  contactsRoot: ['contacts'] as const,
  contact: (id: string) => ['contact', id] as const,
  contactSuggestions: ['contacts-suggestions'] as const,
  contactDuplicates: ['contacts-duplicates'] as const,
  library: ['library'] as const,
  librarySuggestions: ['library-suggestions'] as const,
  libraryLinks: (id: string) => ['library-links', id] as const,
  attachmentRequests: (status: 'open' | 'all') => ['attachment-requests', status] as const,
  attachmentRequestsRoot: ['attachment-requests'] as const,
  aiProviders: ['ai', 'providers'] as const,
  aiUsage: ['ai', 'usage'] as const,
  aiPreferences: ['ai', 'preferences'] as const,
  aiModels: (providerId: string) => ['ai', 'models', providerId] as const,
  rules: ['rules'] as const,
  insights: (from: string, to: string) => ['insights', from, to] as const,
  insightsRoot: ['insights'] as const,
  coverage: ['coverage'] as const,
  sessions: ['sessions'] as const,
  audit: ['audit'] as const,
  workspace: ['workspace'] as const,
  notifications: ['notifications'] as const,
  categories: ['categories'] as const,
  projects: ['projects'] as const,
  project: (id: string) => ['project', id] as const,
  projectThreads: (id: string, filter?: string) => ['project-threads', id, filter ?? 'all'] as const,
  projectThreadsRoot: ['project-threads'] as const,
};
